import routeConfig from "../../../../../../../modules/routeConfig";
import productRoutes from "../../../../../modules/productRoutes";
import UspsApplicantsTable from './pages/UspsApplicantsTable'
import UspsApplicantsEdit from './pages/UspsApplicantsEdit'


export default routeConfig(
    productRoutes([UspsApplicantsTable, UspsApplicantsEdit]),
  );
  